const CleanUrl = (url) => {
    if (url && url.trim() !== '') {
        // Remove the http:// and https:// prefixes
        url = url.trim().replace('http://', '').replace('https://', '').toLowerCase();
        // Remove query parameters
        const queryIndex = url.indexOf('?');
        if (queryIndex > -1) {
            url = url.substring(0, queryIndex);
        }
        // Remove trailing slashes
        url = url.replace(/\/+$/, '');
    }

    return url;
};
export default CleanUrl;
